import { Theme } from '@mui/material';

import button from './components/button';

const componentsOverrides = (theme: Theme) => ({
  ...button(theme),
});

export default componentsOverrides;
